import React from 'react';
import SellerRating from './seller-rating';

const SellerLink = ({
    className,
    sellerMemberId,
    sellerAlias,
    sellerDsrAverage
}) => {
    const hasRating = Math.abs(sellerDsrAverage || 0) >= 0.1;

    return (
        <span className={className}>
            <a href={`/profile/feedback/${sellerMemberId}/${sellerAlias}`}>
                {sellerAlias}
            </a>
            {hasRating && (
                <>
                    &nbsp;
                    <SellerRating
                        sellerDsrAverage={sellerDsrAverage}
                        includeTotal={false}
                    />
                </>
            )}
        </span>
    );
};
export default SellerLink;
